import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import GeneralServices from '../../../app/service/generalServices'
import ConstantsUtil from '../../../context/constantsUtil'
import { Button } from 'primereact/button'
import HandleErrorService from '../../../app/service/handleErrorService'
import ProvisaoService from '../../../app/service/contasAPagar/provisaoService'
import TableFilters from '../../tableFilters'
import CentralService from '../../../app/service/central/centralService'
import AuthService from '../../../app/service/authService'
import EditProvisaoDialog from './editProvisaoDialog'
import TooltipButton from '../../tooltipButton'

class ProvisoesPorProdutoTable extends React.Component {

    constructor(){
        super()
        this.provisaoProdutosTableRef = React.createRef()
        this.provisaoService = new ProvisaoService()
        this.tableFilters = new TableFilters()
        this.centralService = new CentralService()
        this.generalServices = new GeneralServices();
    }

    state = {
        
        provisaoProdutosResponse: {},
        provisaoProdutosList: [],
        valorTotal: null,

        loading: false,
        didUpdated: false,

        displayEditDialog: false,

        filteredList: [],

    }

    componentDidMount(){
        // console.log("mount produtos")
        this.setStates()
    }

    setStates = async () => {
        // if( !this.state.didUpdated || this.props.forceUpdate){
        if(!this.state.didUpdated) {
            // console.log("this.props: ", this.props)
            // console.log("setStates")
            await this.setState({didUpdated: true})
            this.searchProvisaoProdutos()

            
            
            // if(this.props.doneForceUpdate){
            //     this.props.doneForceUpdate()
            // }

        }
    }

    isCMV = () => {
        let isCMV = (this.props.grupo.tipoDescricao === ConstantsUtil.DRECompetenciaGrupoCMV)
        return isCMV
    }

    searchProvisaoProdutosIndividualOuUnificado = () => {
        // console.log("this.props.tipoProdutoList: ", this.props.tipoProdutoList)
        let isCMV = this.isCMV()
        
        if(this.props.unificar){
            if(isCMV){
                return this.centralService.detalhaCMVDreCompetenciaUnificado(this.props.initialDate, this.props.finalDate, this.props.empresasList)
            }
            return this.centralService.searchProvisaoProdutosUnificado(this.props.initialDate, this.props.finalDate, this.props.tipoProdutoList, this.props.empresasList)
        }

        if(isCMV){
            return this.provisaoService.detalhaCMVDreCompetencia(this.props.initialDate, this.props.finalDate)
        }
        // console.log("searchProvisaoProdutosIndividualOuUnificado: ", this.props.tipoProdutoList)
        return this.provisaoService.searchProvisaoProdutos(this.props.initialDate, this.props.finalDate, this.props.tipoProdutoList)

    }

    searchProvisaoProdutos = () => {
        
        // console.log("searchProvisaoProdutos")

        this.setState({loading: true})

        this.searchProvisaoProdutosIndividualOuUnificado()
        .then(response => {
            let dados = response.data
            // console.log("searchProvisaoProdutos: ", dados)
            this.trataResponse(dados)
            this.setState({provisaoProdutosResponse: dados})
            this.setState({provisaoProdutosList: dados.provisaoProdutosList})
            
            if(this.props.onSuccessSearch){
                // console.log("this.props.onSuccessSearch")
                this.props.onSuccessSearch()
            }

        })
        .catch(error => {
            console.log("error: ", error)
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loading: false})
        })
    }

    trataResponse = (dados) => {
        dados.provisaoProdutosList.forEach(provisaoProduto => {
            
            if(!provisaoProduto.provisao.notaFiscal.numero){
                provisaoProduto.provisao.notaFiscal.numero = ''
            }

            if(provisaoProduto.transaction && !provisaoProduto.transaction.tipoProduto){
                provisaoProduto.transaction.tipoProduto = {descricao: ''}
            }

            if(provisaoProduto.transaction && !provisaoProduto.transaction.tipoEstoque){
                provisaoProduto.transaction.tipoEstoque = {descricao: ''}
            }

        })
    }

    getTableHeaders = () => {
        
        const periodo = this.props.initialDate ? this.props.initialDate + " - " + this.props.finalDate : ""
        const periodoLabel = "Período: " + periodo

        return {periodo: periodoLabel}
    }

    getValorTotal = () => {
        if(this.state.valorTotal){
            return this.state.valorTotal
        }

        if(this.state.valorTotal == null && this.state.provisaoProdutosList) {
            let valorTotal = this.calculaValorTotal(this.state.provisaoProdutosList)
            return valorTotal
        }

        return 0
    }

    getValorTotalFormatado = () => {
        let valorTotal = this.getValorTotal()
        return GeneralServices.showFormattedIfNotNull(valorTotal, true)
    }

    calculaCMV = () => {
        let estoqueInicial = this.state.provisaoProdutosResponse?.estoqueInicial?.valor
        let estoqueFinal = this.state.provisaoProdutosResponse?.estoqueFinal?.valor
        let compras = this.getValorTotal()

        let cmv = compras

        // if(estoqueInicial && estoqueFinal){
            cmv = estoqueInicial + compras - estoqueFinal
        // }

        return GeneralServices.showFormattedIfNotNull(cmv, true)
    }
    
    calculaValorTotal = (currentTableList) => {
        if(!currentTableList || currentTableList.length == 0){
            return null
        }
        let valorTotal = 0
        currentTableList.forEach(item => valorTotal += item.transaction.valor)
        this.setState({valorTotal})
        return valorTotal

    }

    getMappedItemToExport = (item) => {
        // console.log("getMappedItemToExport: ", item)
        // console.log("grupo: ", this.props.grupo)

        let mappedItem = {}

        // if(this.props.isExportacaoAutomatica){
        //     mappedItem = {
        //         ['Data de Lançamento']: item.provisao.notaFiscal.dataHoraEntrada.replaceAll("-", "/"),
        //         ['Descrição']: `${item.provisao.notaFiscal.nomeFornecedorOuCliente} (${item.transaction.productInfo.descricao})`,
        //         ['Valor']: item.transaction.valor,
        //         ['Origem']: item.provisao.origemString,
        //         ['Detalhamento']: ConstantsUtil.getDetalhamentoOrigemLancamentoTipoProduto(item.transaction.tipoProduto.descricao),
        //         ['Grupo Gerencial']: GeneralServices.getNomeSemSimboloGrupoDre(this.props.grupo.titulo),
        //         ['Conta Gerencial']: item.transaction.tipoProduto.descricao,
                
        //     }            
        // }

        // else{
            mappedItem = {
                ['Data de Entrada']: item.provisao.notaFiscal.dataHoraEntrada.replaceAll("-", "/"),
                ['Produto/Serviço']: item.transaction.productInfo.descricao,
                ['Tipo de Produto']: item.transaction.tipoProduto.descricao,
                ['Tipo de Estoque']: item.transaction.tipoEstoque.descricao,
                ['Detalhamento']: ConstantsUtil.getDetalhamentoOrigemLancamentoTipoProduto(item.transaction.tipoProduto.descricao),
                ['Fornecedor/Prestador']: item.provisao.notaFiscal.nomeFornecedorOuCliente,
                ['Grupo de Pagamento']: item.provisao.grupoDePagamento ? item.provisao.grupoDePagamento.nome : '',
                ['Origem']: item.provisao.origemString,
                ['Valor']: item.transaction.valor,
                ['N° Nota Fiscal']: item.provisao.notaFiscal.numero,
                ['Histórico']: item.provisao.historico
            }
        // }

        if(this.props.unificar){
            Object.assign(mappedItem, {'Empresa': item.empresa.nome})
        }

        return mappedItem

    }

    onFilterTable = (filteredList) => {
        this.setState({filteredList})
        this.calculaValorTotal(filteredList)
    }

    getListToExport = () => {

        let list = this.state.filteredList && this.state.filteredList.length > 0 ? this.state.filteredList : this.state.provisaoProdutosList

        let exportList = list.map(item => {
            return this.getMappedItemToExport(item)
        })

        if(!this.props.isExportacaoAutomatica){
            exportList.push(
                {
                    ['Data de Entrada']: '',
                    ['Produto/Serviço']: ConstantsUtil.totaisTableUpperCaseLabel,
                    ['Tipo de Produto']: '',
                    ['Valor']: this.getValorTotalFormatado()
                }            
            )
        }
        
        return exportList
    }    

    getFilenameToExport = () => {
        // return `${this.isFiltroDataLancamento() ? 'Lançamentos_de_Provisão_de_Pagamento' : 'Pagamentos' }_de_${this.props.initialDate}_a_${this.props.finalDate}`
        return this.props.header
    }    

    exportXLSX = () => {
        // console.log("export")
        // console.log(this.props.tipoProdutoList)
        AuthService.startBlockUi()
        let exportList = this.getListToExport()
        // console.log("exportList: ", exportList)
        GeneralServices.exportExcel(exportList, "Vendas", this.getFilenameToExport())
        AuthService.stopBlockUi()
    }
    
    exportPDF = () => {
        let columns = [
            {field: ['Data de Entrada'], header:"Data de Entrada"},
            {field: ['Produto/Serviço'], header:"Produto/Serviço"},
            {field: ['Tipo de Produto'], header:"Tipo de Produto"},
            {field: ['Tipo de Estoque'], header:"Tipo de Estoque"},
            {field: ['Fornecedor/Prestador'], header:"Fornecedor/Prestador"},
            {field: ['Valor'], header:"Valor"},
            {field: ['N° Nota Fiscal'], header:"N° Nota Fiscal"},
        ]

        if(this.props.unificar){
            columns.push({field:['Empresa'], header:"Empresa"})
        }

        let exportColumns = columns.map(col => ({ title: col.header, dataKey: col.field }))

        let exportList = this.getListToExport()
        GeneralServices.exportPdf(this.getFilenameToExport(), exportColumns, exportList)
    }

    editProvisao = async provisaoProduto => {
        
        // console.log("editProvisao: ", provisaoProduto)

        await this.setState({idProvsisaoToEdit: provisaoProduto.provisao.id})
        await this.setState({empresaProvisaoToEdit: provisaoProduto.empresa})
        this.setState({displayEditDialog: true})
        
    }

    hideEditDialog = async () => {
        await this.setState({
            displayEditDialog: false,
            idProvsisaoToEdit: '',
            empresaProvisaoToEdit: ''
        })
    }

    reRenderEditDialog = async () => {
        AuthService.startBlockUi()
        await this.setState({displayEditDialog: false})
        await this.generalServices.sleep(500)
        await this.setState({displayEditDialog: true})
        AuthService.stopBlockUi()
    }    


    render() {

        const renderBotaoExportarExcel = () => {
            return (
                <TooltipButton
                    label=""
                    icon="pi pi-file-excel"
                    className="p-button-success small-font small-button"
                    style={{maxWidth:'150px'}}
                    onClick={this.exportXLSX}
                    tooltip={ConstantsUtil.exportXlsxLabel}
                    tooltipOptions={{position: 'right'}}
                />
            )
        }        

        const renderBotaoExportarPDF = () => {
            return (
                <Button
                    label=""
                    icon="pi pi-file-pdf"
                    className="p-button-danger small-font small-button"
                    onClick={this.exportPDF}
                    style={{marginLeft: '10px', maxWidth:'150px'}}
                    tooltip={ConstantsUtil.exportPdfLabel}
                    tooltipOptions={{position: 'top'}}
                />
            )
        }

        const dataCompetenciaFilterElement = this.tableFilters.renderTableFilter(
            this.provisaoProdutosTableRef,
            this.state.selectedDataCompetencia,
            this.state.provisaoProdutosList,
            "selectedDataCompetencia",
            (name, value) => this.setState({[name]: value}),
            'provisao.dataLancamento',
            '100%',
            "Data Competência"
        )

        const nomeProdutoFilterElement = this.tableFilters.renderTableFilter(
            this.provisaoProdutosTableRef,
            this.state.selectedProduto,
            this.state.provisaoProdutosList,
            "selectedProduto",
            (name, value) => this.setState({[name]: value}),
            'transaction.productInfo.descricao',
            '300px',
            "Produto"
        )

        const tipoProdutoFilterElement = this.tableFilters.renderTableFilter(
            this.provisaoProdutosTableRef,
            this.state.selectedTipoProduto,
            this.state.provisaoProdutosList,
            "selectedTipoProduto",
            (name, value) => this.setState({[name]: value}),
            'transaction.tipoProduto.descricao',
            '300px',
            "Tipo do Produto"
        )

        const tipoEstoqueFilterElement = this.tableFilters.renderTableFilter(
            this.provisaoProdutosTableRef,
            this.state.selectedTipoEstoque,
            this.state.provisaoProdutosList,
            "selectedTipoEstoque",
            (name, value) => this.setState({[name]: value}),
            'transaction.tipoEstoque.descricao',
            '300px',
            "Tipo do Estoque"
        )

        const fornecedorFilterElement = this.tableFilters.renderTableFilter(
            this.provisaoProdutosTableRef,
            this.state.selectedFornecedor,
            this.state.provisaoProdutosList,
            "selectedFornecedor",
            (name, value) => this.setState({[name]: value}),
            'provisao.notaFiscal.nomeFornecedorOuCliente',
            '300px',
            "Fornecedor"
        )

        const grupoDePagamentoFilterElement = this.tableFilters.renderTableFilter(
            this.provisaoProdutosTableRef,
            this.state.selectedGrupoDePagamento,
            this.state.provisaoProdutosList,
            "selectedGrupoDePagamento",
            (name, value) => this.setState({[name]: value}),
            'provisao.grupoDePagamento.nome',
            '100%',
            "Grupo de Pagamento"
        )

        const origemFilterElement = this.tableFilters.renderTableFilter(
            this.provisaoProdutosTableRef,
            this.state.selectedOrigemProvisao,
            this.state.provisaoProdutosList,
            "selectedOrigemProvisao",
            (name, value) => this.setState({[name]: value}),
            'provisao.origemString',
            '100%',
            "Origem"
        )

        const valorProdutoFilterElement = this.tableFilters.renderTableFilter(
            this.provisaoProdutosTableRef,
            this.state.selectedValorProduto,
            this.state.provisaoProdutosList,
            "selectedValorProduto",
            (name, value) => this.setState({[name]: value}),
            'transaction.valor',
            '300px',
            "Valor do Produto"
        )

        const notaFiscalFilterElement = this.tableFilters.renderTableFilter(
            this.provisaoProdutosTableRef,
            this.state.selectedNotaFiscal,
            this.state.provisaoProdutosList,
            "selectedNotaFiscal",
            (name, value) => this.setState({[name]: value}),
            'provisao.notaFiscal.numero',
            '300px',
            "N° NF"
        )

        const empresaFilterElement = this.tableFilters.renderTableFilter(
            this.provisaoProdutosTableRef,
            this.state.selectedEmpresa,
            this.state.provisaoProdutosList,
            "selectedEmpresa",
            (name, value) => this.setState({[name]: value}),
            'empresa.nome',
            '100%',
            "Empresa"
        )

        const historicoFilterElement = this.tableFilters.renderTableFilter(
            this.provisaoProdutosTableRef,
            this.state.selectedHistorico,
            this.state.provisaoProdutosList,
            "selectedHistorico",
            (name, value) => this.setState({[name]: value}),
            'provisao.historico',
            '100%',
            "Histórico"
        )

        const renderOperadorMatematico = (operador) => {
            return(
                <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontWeight: "bold",
                    height: "20px",
                    fontSize: "20px"
                }}
                >
                    {operador}
                </div>
            )
        }

        const renderButtonCMV = (label, valor, buttonClass, tooltip) => {
            return (
                <Button
                    label={`${label}: ${valor}`}
                    className={`p-button-${buttonClass}  small-font small-button`}
                    tooltip={tooltip}
                    tooltipOptions={{position: 'top'}}
                />
            )
        }

        const renderHeader = () => {
            return (
                <div className = "card-header">
                <div className='col-md-12'>
                    <div className='row'>
                            {renderBotaoExportarExcel()}
                            {renderBotaoExportarPDF()}

                        <div
                            className='col-md d-flex justify-content-end'
                            style={{marginLeft: '40px'}}
                        >
                            
                            {renderValoresButtons()}


                        </div>
                    </div>
                    
                </div>
                </div>                
            )
        }

        const renderValoresButtons = () => {
            if(this.isCMV()){
                return (
                    <>
                        {renderButtonCMV(
                            'Estoque Inicial',
                            GeneralServices.showFormattedIfNotNull(this.state.provisaoProdutosResponse?.estoqueInicial?.valor, true),
                            '',
                            this.state.provisaoProdutosResponse?.estoqueInicial?.dataLancamento
                            )
                        }
                        
                        {renderOperadorMatematico("➕")}

                        {renderButtonCMV('Compras', this.getValorTotalFormatado(), 'success')}
                        
                        {renderOperadorMatematico("➖")}
                        
                        {renderButtonCMV(
                            'Estoque Final',
                            GeneralServices.showFormattedIfNotNull(this.state.provisaoProdutosResponse?.estoqueFinal?.valor, true),
                            'danger',
                            this.state.provisaoProdutosResponse?.estoqueFinal?.dataLancamento
                            )
                        }

                        {renderOperadorMatematico("=")}

                        {renderButtonCMV('CMV', this.calculaCMV(), 'success')}
                    </>
                )
            }

            return (
                <>
                    <div className='col-md-8'>

                    </div>
                    {renderButtonCMV('Valor Total', this.calculaCMV(), 'success')}
                </>
            )

        }

        const renderEmpresaColumn = () => {
            if(this.props.unificar)
            {
                return (
                    <Column
                        header="Empresa"
                        field="empresa.nome"
                        // body = {rowData => GeneralServices.showFormattedIfNotNull(rowData.valorTotalProvisao, true)}
                        sortable style ={ {width: '30px'} }
                        filter filterElement={empresaFilterElement}
                    />
                )
            }
        }

        const renderTable = () => {
            return (
                <DataTable
                    ref={this.provisaoProdutosTableRef}
                    value={this.state.provisaoProdutosList}
                    onValueChange={this.onFilterTable}
                    className="p-datatable-sm small-font"
                    rowHover
                    // rowClassName={this.rowClass}
                    showGridlines
                    scrollable
                    scrollHeight={ this.props.insideDialog ? '280px' : "400px"}
                    emptyMessage={ConstantsUtil.nenhumLancamentoEncontradoMessage}
                    loading={this.state.loading}
                    dataKey="provisao.id"
                    paginator rows={ConstantsUtil.initialTableQuantityOption}
                    paginatorTemplate={GeneralServices.tablePaginatorTemplate(ConstantsUtil.initialTableQuantityOption, this.state.provisaoProdutosList.length)}
                    currentPageReportTemplate="Mostrando de {first} ao {last} de {totalRecords} lançamentos"
                >

                    <Column
                        header="Data de Competência"
                        field="provisao.dataLancamento"
                        sortable style ={ {width: '35px'} }
                        filter filterElement={dataCompetenciaFilterElement}
                    />

                    <Column
                        header="Produto/Serviço"
                        field="transaction.productInfo.descricao"
                        body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.transaction.productInfo.descricao, rowIndex)}
                        sortable style ={ {width: '70px'} }
                        filter filterElement={nomeProdutoFilterElement}
                    />

                    <Column
                        header="Tipo de Produto" 
                        field="transaction.tipoProduto.descricao"
                        body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.transaction.tipoProduto.descricao, rowIndex)}
                        sortable style ={ {width: '40px'} }
                        filter filterElement={tipoProdutoFilterElement}
                    />

                    <Column
                        header="Tipo de Estoque" 
                        field="transaction.tipoEstoque.descricao"
                        body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.transaction.tipoEstoque.descricao, rowIndex)}
                        sortable style ={ {width: '40px'} }
                        filter filterElement={tipoEstoqueFilterElement}
                    />

                    <Column
                        header="Fornecedor/Prestador"
                        field="provisao.notaFiscal.nomeFornecedorOuCliente"
                        sortable style ={ {width: '80px'} }
                        filter filterElement={fornecedorFilterElement}
                    />

                    <Column
                        header="Grupo de Pagamento"
                        field="provisao.grupoDePagamento.nome"
                        sortable style ={ {width: '80px'} }
                        filter filterElement={grupoDePagamentoFilterElement}
                    />

                    <Column
                        header="Origem"
                        field="provisao.origemString"
                        sortable style ={ {width: '60px'} }
                        filter filterElement={origemFilterElement}
                        body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.provisao.origemString, rowIndex)}
                    />

                    <Column
                        header="Valor do Produto" 
                        field="transaction.valor" 
                        sortable style ={ {width: '40px'} }
                        filter filterElement={valorProdutoFilterElement}
                        body = {rowData => GeneralServices.showFormattedIfNotNull(rowData.transaction.valor, true)}
                    />

                    <Column
                        header="Nota Fiscal"
                        field="provisao.notaFiscal.numero" 
                        sortable style ={ {width: '45px'} }
                        filter filterElement={notaFiscalFilterElement}
                        body = {rowData => {
                            const prefixo = rowData.provisao.nfse ? "NFSe N° " : "Nota Fiscal N° ";
                            return rowData.provisao.notaFiscal?.numero
                                ? prefixo + rowData.provisao.notaFiscal.numero
                                : "S/N";
                        }}
                    />

                    {renderEmpresaColumn()}

                    <Column
                        header="Histórico"
                        style ={ {width: '60px'} }
                        field="provisao.historico"
                        body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.provisao.historico, rowIndex)}
                        sortable
                        filter filterElement={historicoFilterElement}
                    />

                    <Column header="Ações" body={actionBody} style ={ {width: "40px"} }
                    />                    

                </DataTable>
            )
        }

        const actionBody = (provisaoProduto) => {
            return (
                <React.Fragment>
                    <TooltipButton
                        tooltip='Editar'
                        icon="pi pi-pencil"
                        onClick={() => this.editProvisao(provisaoProduto)}
                    />
                </React.Fragment>
            );
        }

        const renderEditProvisaoDialog = () => {
            return (
                <EditProvisaoDialog
                    visible={this.state.displayEditDialog}
                    provisaoId={this.state.idProvsisaoToEdit}
                    empresa={this.state.empresaProvisaoToEdit}
                    search={this.searchProvisaoProdutos}
                    startLoadingTable={() => this.setState({loading: true})}
                    finishLoadingTable={() => this.setState({loading: false})}
                    hideDialog={this.hideEditDialog}
                    reRender={this.reRenderEditDialog}
                    insideDre={this.props.insideDre}
                    unificar={this.props.unificar}
                />
            )
        }        

        if(this.props.isExportacaoAutomatica){
            return(
                <></>
            )
        }

        return (
            <>
                {renderHeader()}
                {renderTable()}
                {renderEditProvisaoDialog()}
            </>
        )
    }

}

export default ProvisoesPorProdutoTable